export const getMockAccessIndex = (index: number, pagination: { page: number }) => {
  return index + (5 * pagination?.page || 0)
}
